// Shared lab test structures used by Laboratory entry, Clinician view, and Admin view.

export const fbcStructure = [
  {
    category: 'WHITE BLOOD CELLS AND WBC MORPHOLOGY',
    tests: [
      { name: 'White Blood Cells (WBC)', range: '4-10', unit: 'x10^3/uL' },
      { name: 'Neutrophils Neu %', range: '40-70', unit: '%' },
      { name: 'Lymphocytes LYMP %', range: '20-45', unit: '%' },
      { name: 'Monocytes MONO %', range: '2-10', unit: '%' },
      { name: 'Basophils BASO %', range: '<1', unit: '%' },
      { name: 'Eosinophils EOS%', range: '<6', unit: '%' },
      { name: 'Neutrophils NEUT#', range: '1.7-7.0', unit: 'x10^3/uL' },
      { name: 'Lymphocyte LYM#', range: '1.0-3.0', unit: 'x10^3/uL' },
      { name: 'Monocyte MON #', range: '0.3-0.9', unit: 'x10^3/uL' },
      { name: 'Basophils BASO#', range: '<0.3', unit: 'x10^3/uL' },
      { name: 'Eosinophils EOS#', range: '0.05-0.5', unit: 'x10^3/uL' },
    ],
  },
  {
    category: 'RED CELLS AND RBC LINE',
    tests: [
      { name: 'Red Blood Cells (RBCs)', range: '4.3-5.572', unit: 'x10^6/uL' },
      { name: 'Haematocrit', range: '38.8-54', unit: '%' },
      { name: 'Haemoglobin', range: '11.5-18.5', unit: 'g/dl' },
      { name: 'MCV', range: '81.2-95.1', unit: 'fL' },
      { name: 'MCH', range: '26.6-33.3', unit: 'pg/cell' },
      { name: 'MCHC', range: '31.5-36.3', unit: 'g/dl' },
      { name: 'RDW-SD', range: '35-55', unit: 'fL' },
      { name: 'RDW-CV', range: '11.5-14.5', unit: '%' },
    ],
  },
  {
    category: 'PLATELETS',
    tests: [
      { name: 'Platelets (PLT)', range: '100-400', unit: 'x10^3/uL' },
      { name: 'PDW', range: '9-18.5', unit: '%' },
      { name: 'MPV', range: '7.65-11.5', unit: 'fL' },
      { name: 'P-LCR', range: '21-45', unit: '%' },
    ],
  },
]

export const urinalysisTests = [
  { name: 'LEU', fullName: 'Leukocytes' },
  { name: 'NIT', fullName: 'Nitrites' },
  { name: 'URO', fullName: 'Urobilinogen' },
  { name: 'PRO', fullName: 'Protein' },
  { name: 'pH', fullName: 'pH' },
  { name: 'BLO', fullName: 'Blood' },
  { name: 'SG', fullName: 'Specific Gravity' },
  { name: 'KET', fullName: 'Ketones' },
  { name: 'BIL', fullName: 'Bilirubin' },
  { name: 'GLU', fullName: 'Glucose' },
]

export const testosteroneTests = [
  {
    name: 'Testosterone, Total',
    rangeMale: '1.66-8.11',
    rangeFemale: '0.13-1.08',
    unit: 'ng/mL',
    method: 'Immunofluorescence',
  },
]

export const isFBCTest = (testName: string) => {
  const t = testName.toLowerCase()
  return t === 'fbc' || t.includes('full blood count')
}

export const isUrinalysisTest = (testName: string) =>
  testName.toLowerCase().includes('urinalysis')

export const isTestosteroneTest = (testName: string) =>
  testName.toLowerCase().includes('testosterone')
